import { DeleteModal, IconFont, PageContainer, SignTitle, TableTag } from '@/components'
import { SyncOutlined } from '@ant-design/icons'
import { Breadcrumb, Button, Collapse, Form, Progress, Space, Typography } from 'antd'
import styled from 'styled-components'
import { List } from './list'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import {
  useGetTaskBasic,
  useGetTaskStd,
  useGetTaskDetailList,
  useGetTaskLog,
  useUpStart,
} from './utils'
import { useEffect, useState } from 'react'
import { DeleteTaskModal, EndTaskModal } from '../activity'
import { useDeleteTask, useEndTask, useGetTaskReport } from '../activity/utils'
import { GetTaskBasic, GetTaskDetailListData } from '@/api/fishing-task-detail'
import { TaskMsg } from './task-message'
import { TaskAbstract } from './task-name'
import { CreateReport } from '@/components/create-report'
import { useAddReport } from '@/pages/evaluation/report-task/utils'
import { t } from '@/i18n'
const { useForm } = Form
// 指定图表的配置项和数据 折线图

const TaskDetail = () => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  console.log('id', id)
  const [endTask, endTaskLoading] = useEndTask()
  const navigate = useNavigate()
  const { state }: any = useLocation()

  const [getTaskDetailListParams, setGetTaskDetailListParams] = useState<GetTaskDetailListData>({
    campaign_id: id,
    keyword: '',
    tag_list: [],
    dept_name: '',
    aware: '',
    limit: 50,
    page: 1,
    status: 0,
  })
  const [taskDetailList, taskDetailListLoading, getTaskDetailList] = useGetTaskDetailList({
    getTaskDetailListParams,
  })
  const [form] = useForm()
  const [getTaskReport, createLoading] = useAddReport()
  const [statement, setStatement] = useState({ visible: false })
  const confirmAddGroup = async (values: any) => {
    try {
      await getTaskReport({
        task_list: [{ task_name: getTaskBasic?.data?.name, campaign_id: id }],
        ...values,
      })
      form.resetFields()
      setStatement({ visible: false })
      window.open('/report/task/task-report?tab=1', '_self')
    } catch (error) {}
  }
  const endTaskHandler = ids => () => {
    setEndTaskModal({ visibel: true, id: ids })
  }

  const endTaskConfirmHandler = async () => {
    if (!endTaskModal.id) return
    try {
      await endTask({ id: endTaskModal.id })
      await getTaskBasicList()
      setEndTaskModal({ visibel: false })
    } catch (error) {}
  }
  const [taskStdProps, setTaskStdProps] = useState({
    ids: id,
    deptName: '',
    emailType: '',
  })

  const [taskStd, getTaskStd] = useGetTaskStd(taskStdProps)
  const [deleteTask, deleteTaskLoading] = useDeleteTask()

  const [deleteTaskModal, setDeleteTaskModal] = useState<DeleteTaskModal>({
    visibel: false,
  })
  const [endTaskModal, setEndTaskModal] = useState<EndTaskModal>({
    visibel: false,
  })
  useEffect(() => {
    if (taskStdProps.deptName !== '') {
      getTaskStd()
    }
    if (taskStdProps.emailType !== '') {
      getTaskStd()
    }
  }, [taskStdProps])
  useEffect(() => {
    if (id) {
      setTaskBasicParams({ id: id })
    }
  }, [id])
  const [taskBasicParams, setTaskBasicParams] = useState<GetTaskBasic>({ id: id })
  const [detailList, setDetailList] = useState(null)
  const [getTaskBasic, getTaskBasicLoading, getTaskBasicList] = useGetTaskBasic({
    GetTaskBasicParams: taskBasicParams,
  })
  const [getTaskLogList, taskLogLoad, getTaskLog] = useGetTaskLog({
    GetTaskLogParams: taskBasicParams,
  })
  useEffect(() => {
    if (taskBasicParams.id) {
      getTaskBasicList().catch(_ => {})
    }
  }, [taskBasicParams?.id])
  useEffect(() => {
    if (getTaskBasic?.data.email_type) {
      setTaskStdProps(origin => ({
        ...origin,
        emailType: getTaskBasic.data.email_type === '钓鱼链接' ? '1' : '2',
      }))
    }
  }, [getTaskBasic])
  const deleteTaskHandler = async () => {
    try {
      await deleteTask({ id: deleteTaskModal?.id })
      navigate('/validation/awareness/phishing?tab=task', {
        state: state?.pagination || { page: 1, limit: 10 },
      })
    } catch (error) {}
  }

  const [upStart] = useUpStart()
  const [collapse, setCollapse] = useState(['2'])
  return (
    <PageContainer
      crumbs={
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              style={{
                width: '24px',
                height: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '12px',
                background: '#fff',
                border: '0px',
              }}
              icon={<IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />}
              onClick={() => {
                navigate('/validation/awareness/phishing?tab=task')
              }}
            />

            <Breadcrumb>
              <Breadcrumb.Item>{t('任务详情')}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            {getTaskBasic?.data?.status * 1 === 2 && (
              <Button type="primary" onClick={endTaskHandler(id)}>
                {t('结束任务')}
              </Button>
            )}
            {getTaskBasic?.data?.status * 1 === 1 && (
              <Button
                type="primary"
                onClick={async () => {
                  try {
                    await upStart({ id: id })
                    await getTaskBasicList()
                  } catch (e) {}
                }}
              >
                {t('立即开始')}
              </Button>
            )}
            {getTaskBasic?.data?.status * 1 === 3 && <Button type="primary">{t('已完成')}</Button>}
            {getTaskBasic?.data?.status * 1 === 3 && (
              <Button
                onClick={() => {
                  setStatement({ visible: true })
                }}
              >
                {t('生成报表')}
              </Button>
            )}
            <Button
              onClick={() => {
                setDeleteTaskModal({
                  visibel: true,
                  id: [id],
                })
              }}
              style={{ marginRight: '2px' }}
              className="delete"
            >
              {t('删除')}
            </Button>
            {getTaskBasic?.data?.status * 1 === 2 && (
              <Button
                onClick={() => {
                  getTaskStd()
                  getTaskDetailList()
                  getTaskLog()
                  setDetailList(Date.now())
                  getTaskBasicList().catch(_ => {})
                }}
                icon={<SyncOutlined />}
                style={{
                  marginLeft: '5px',
                  background: '#fff',
                  border: '0px',
                }}
              />
            )}
          </Space>
        </div>
      }
    >
      <TaskDetailContainer>
        <TopCard bordered={false} activeKey={collapse}>
          <Collapse.Panel
            header={
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                  <SignTitle style={{ width: 400 }}>
                    <Typography.Text
                      ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
                    >
                      {t('任务名称：')}
                      {getTaskBasic?.data?.name}
                    </Typography.Text>
                  </SignTitle>
                  <div style={{ display: 'flex' }}>
                    {collapse.length === 0 && (
                      <div>
                        {t('执行日期：')} {getTaskBasic?.data?.start_time}
                      </div>
                    )}
                  </div>
                </div>
                {collapse.length === 0 && (
                  <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ width: 200 }}>
                      {t('任务进度：')}
                      {getTaskBasic?.data?.status * 1 === 1 && (
                        <TableTag background="#FFF3E1" color="#FFAD31">
                          {t('预定')}
                        </TableTag>
                      )}
                      {getTaskBasic?.data?.status * 1 === 2 && (
                        <TableTag background="#e9f1ff" color="#2973ff">
                          {t('进行中')}
                        </TableTag>
                      )}
                      {getTaskBasic?.data?.status * 1 === 3 && (
                        <TableTag background="#f2f9eb" color="#67c23a">
                          {t('已完成')}
                        </TableTag>
                      )}
                    </div>
                    <Progress
                      strokeColor={{
                        '0%': '#fff',
                        '100%': '#0346F2',
                      }}
                      success={{ percent: -1 }}
                      percent={
                        (getTaskBasic?.data?.status === 1 && 0) ||
                        (getTaskBasic?.data?.status === 2 &&
                          Number(
                            Number(
                              getTaskBasic?.data?.rate +
                                ((getTaskLogList?.items?.length || 1) * 50) /
                                  (taskStd.create_num || 1),
                            ).toFixed(0),
                          )) ||
                        (getTaskBasic?.data?.status === 3 && 100)
                      }
                    />
                  </div>
                )}
              </div>
            }
            key="2"
            showArrow={false}
          >
            <TaskMsg
              getTaskBasic={getTaskBasic}
              getTaskLogList={getTaskLogList}
              taskBasicsInfo={taskStd}
            />
          </Collapse.Panel>
        </TopCard>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Show
            onClick={() => setCollapse(collapse.length === 0 ? ['2'] : [])}
            visible={collapse.length > 0}
          >
            <div>{collapse.length > 0 ? t('收起') : t('展开')}</div>
            <IconFont className="icon" type="icon-gengduo2" />
          </Show>
        </div>
        <TaskAbstract
          taskStd={taskStd}
          getTaskStd={getTaskStd}
          getTaskBasic={getTaskBasic}
          setTaskStdProps={setTaskStdProps}
          taskStdProps={taskStdProps}
        />

        <List
          group={getTaskBasic?.data}
          type={getTaskBasic?.data?.email_type}
          status={getTaskBasic?.data?.status}
          getTaskDetailList={getTaskDetailList}
          getTaskStd={getTaskStd}
          setGetTaskDetailListParams={setGetTaskDetailListParams}
          getTaskDetailListParams={getTaskDetailListParams}
          taskDetailList={taskDetailList}
          getTaskBasic={getTaskBasic}
          detailList={detailList}
        />
      </TaskDetailContainer>
      <CreateReport
        visible={statement.visible}
        createLoading={createLoading}
        templateType={1}
        onConfirm={e => {
          confirmAddGroup(e)
        }}
        onCancel={() => {
          setStatement({ visible: false })
        }}
      />

      <DeleteModal
        onOk={deleteTaskHandler}
        visible={deleteTaskModal.visibel}
        title={t('删除任务')}
        text={t('此操作将永久删除该任务,是否继续?')}
        confirmLoading={deleteTaskLoading}
        onCancel={() => {
          setDeleteTaskModal({ visibel: false })
        }}
      />
      <DeleteModal
        onOk={endTaskConfirmHandler}
        visible={endTaskModal.visibel}
        title={<SignTitle show>提示</SignTitle>}
        text="停止任务后事件将不再被记录，请确认是否立即停止任务？"
        confirmLoading={endTaskLoading}
        onCancel={() => {
          setEndTaskModal({ visibel: false })
        }}
      />
    </PageContainer>
  )
}
export default TaskDetail

const TaskDetailContainer = styled.div`
  width: 100%;
`
const TopCard = styled(Collapse)`
  border-radius: 6px;
  overflow: hidden;
  .ant-collapse-header,
  .ant-collapse-content-box {
    background: #fff !important;
  }
  .ant-collapse-header {
    padding: 20px 24px !important;
  }
  .ant-collapse-item {
    border: 0 !important;
  }
  border: 0;
  .task-message {
    display: flex;
    margin-bottom: 18px;
  }
  .ant-card-head,
  .ant-card-body {
    padding-left: 16px;
    padding-right: 16px;
  }
`
const Icon = styled(IconFont)`
  margin-left: 16px;
  transition: all 0.3s;
  font-size: 13px;
`
interface ShowProps {
  visible: boolean
}
const Show = styled.div<ShowProps>`
  width: 130px;
  height: 20px;
  background-color: #e7e9f3;
  clip-path: polygon(0 0, 35px 100%, calc(100% - 35px) 100%, 100% 0);
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  color: #4238c9;
  .icon {
    rotate: ${props => (props.visible ? ' 270deg' : '90deg')};
  }
`
